import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'

const HeaderSettingsHeroAlignment = ({
  classes,
  themeSettings,
  onThemeSettingsChange,
}) => {
  // Handle position selection
  const handlePositionSelect = position => {
    onThemeSettingsChange(position)
  }

  // Position option styles
  const getPositionStyle = position => {
    return {
      border:
        themeSettings.selectedPosition === position
          ? '1px solid var(--mcg-blue, #015FFB)'
          : '1px solid var(--Gray-Lighter, #E5E7EB)',
    }
  }

  // Position options data - only left and right for hero
  const positionOptions = [
    { value: 'left', label: 'Left' },
    { value: 'right', label: 'Right' },
  ]
  const pageUrl = window.location.pathname.split('/')[1]

  return (
    <div className={classes.imageContent}>
      <div className={classes.imageContainer}>
        <Typography className={classes.imageHeader}>
          Content alignment
        </Typography>
        <Typography className={classes.imageText}>
          Choose how to position the image and content.
        </Typography>
      </div>

      {/* Position options */}
      <div className={classes.positionContainer}>
        {positionOptions.map(option => (
          <div className={classes.positionDiv} key={option.value}>
            <div
              className={classes.positionContent}
              onClick={() => handlePositionSelect(option.value)}
              style={getPositionStyle(option.value)}
            >
              <img
                src={`/assets/editor-file/landing-page/${
                  pageUrl === 'collection' ? 'collection' : 'course'
                }/hero/${option.value}.svg`}
                alt={`${option.label} alignment`}
              />
            </div>
            <div className={classes.positionTextDiv}>
              <Typography className={classes.positionText}>
                {option.label}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderSettingsHeroAlignment)
